export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-05.ee48f76b.jpg";